import { cx } from '@linaria/core';
import { useRef } from 'react';
import { Tooltip } from '@ui/kit';
import { useTruncatedState, FormattedList, Chevron } from '@utils/react';
import { labelCls, valueCls, iconCls, throbberCls, iconWrapperCls, buttonCls } from './select-trigger.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SelectTrigger(props) {
  const valuesRef = useRef(null);
  const isTruncated = useTruncatedState(valuesRef, props.selectedValues?.join("-") ?? "");
  const handleClick = () => {
    if (props.loading || props.disabled) {
      return;
    }
    props.onClick();
  };
  return /*#__PURE__*/jsxs("button", {
    type: "button",
    className: cx(buttonCls, (props.disabled || props.loading) && "disabled"),
    onClick: handleClick,
    "aria-disabled": props.loading || props.disabled,
    children: [/*#__PURE__*/jsxs("span", {
      className: labelCls,
      children: [props.label, " ", props.optional && /*#__PURE__*/jsx("span", {
        className: "dimmed",
        children: "(valgfri)"
      })]
    }), /*#__PURE__*/jsxs("span", {
      className: valueCls,
      children: [props.selectedValues && props.selectedValues.length > 0 ? /*#__PURE__*/jsx(Tooltip, {
        containerRef: valuesRef,
        placement: "top",
        body: /*#__PURE__*/jsx(FormattedList, {
          children: props.selectedValues
        }),
        disabled: !isTruncated,
        ariaType: undefined,
        children: ref => /*#__PURE__*/jsx("span", {
          ref: ref,
          children: /*#__PURE__*/jsx(FormattedList, {
            children: props.selectedValues
          })
        })
      }) : props.valuePlaceholder, /*#__PURE__*/jsxs("div", {
        className: cx(iconWrapperCls),
        children: [/*#__PURE__*/jsx("span", {
          className: cx(iconCls, !props.loading && "active"),
          "aria-hidden": props.loading,
          children: /*#__PURE__*/jsx(Chevron, {
            className: "chevron",
            lineWidth: 1.5,
            size: 8
          })
        }), /*#__PURE__*/jsx("span", {
          className: cx(iconCls, props.loading && "active"),
          "aria-hidden": !props.loading,
          "aria-label": "Indl\xE6ser",
          children: /*#__PURE__*/jsx("span", {
            className: throbberCls
          })
        })]
      })]
    })]
  });
}

export { SelectTrigger };
//# sourceMappingURL=select-trigger.js.map
